import { SxProps, Theme } from '@mui/system';

export const timePicker: SxProps<Theme> = {
  marginTop: '16px',
  marginBottom: '8px',
  '& .MuiOutlinedInput-root': {
    height: '40px',
    width: '150px',
  },
  marginLeft: '46px',
};

export const datePicker: SxProps<Theme> = {
  marginTop: '16px',
  marginBottom: '8px',
  '& .MuiOutlinedInput-root': {
    height: '40px',
    width: '150px',
  },
};
